import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Autoplay, Pagination, Navigation } from "swiper/modules";

const HeroSection = () => {
  return (
    <div className="w-full h-[568px] bg-white flex items-center justify-center">
      <div className="container max-w-[1240px] mx-auto">
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          // navigation={true}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
        >
          <SwiperSlide>
            {" "}
            <img
              src={require("../../assets/WebFront/Hero/image 242.png")}
              alt=""
              className="w-[1240px] h-[495px] rounded-[11px]"
            />
          </SwiperSlide>
          <SwiperSlide>
            {" "}
            <img
              src={require("../../assets/WebFront/Hero/image 397.jpg")}
              alt=""
              className="w-[1240px] h-[495px] rounded-[11px]"
            />
          </SwiperSlide>
          <SwiperSlide>
            {" "}
            <img
              src={require("../../assets/WebFront/Hero/image 400.jpg")}
              alt=""
              className="w-[1240px] h-[495px] rounded-[11px]"
            />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default HeroSection;
